import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import SearchSWO from "./SearchSWO";

let API_URL = "/m-orders";
let COMPONENT_URL = "/manufacturer/m-orders";
let COMPONENT_DETAILS_URL = "/manufacturer/m-orders/details";

let filterBy = [
  { name: "All", value: "all" },
  { name: "ID", value: "m_woId" },
  { name: "Order Status", value: "orderStatus" },
  { name: "Production Status", value: "productionStatus" },
];

let limits = [5, 10, 15, 20];

export default function MOrders() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useSelector((state) => state.user.userInfo);

  /*   All States
   ********************************************* */
  const [MOrders, setMOrders] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );

  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }

  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }

  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const handleFilterBy = (filter) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filter);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  const getMOrders = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setMOrders(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const deleteMWorkOrder = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete(`m-order/${id}`, {
        headers: authHeader(),
      });
      setLoading(false);
      if (data.success) {
        dispatch(
          setNotification({
            message: "Work order deleted successfully",
            type: "success",
          })
        );
        getMOrders();
      }
      if (!data.success) {
        dispatch(
          setNotification({
            message: data.message || "Failed to delete work order",
            type: "error",
          })
        );
      }
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  const table_head = [
    { name: "ID", value: "m_woId" },
    { name: "Job name", value: "jobName" },
    { name: "Customer Name", value: "customerName" },
    { name: "Order Status", value: "orderStatus" },
    { name: "Production Status", value: "productionStatus" },
    { name: "createdBy", value: "createdBy" },
    // { name: "Last Updated By", value: "lastUpdatedBy" },
    // { name: "Last Updated At", value: "updatedAt" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-1 me-0">{item.m_woId}</td>
      <td className="py-1 me-0">{item?.WorkOrder?.jobName}</td>
      <td className="py-1 me-0">{item.customer?.customerName}</td>
      <td className="py-1 me-0">{item.orderStatus}</td>
      <td className="py-1 me-0">{item.productionStatus}</td>
      <td className="py-1 me-0">{`${item.creator?.firstName} ${item.creator?.lastName}`}</td>
      {/* <td className="py-1 me-0">{`${item.updater?.firstName} ${item.updater?.lastName}`}</td>
      <td className="py-1 me-0">{convertSqlTimestampToDate(item.updatedAt)}</td> */}

      <td className="table-action py-1 me-0">
        <div className="d-flex align-items-center">
          <Link
            to={`${COMPONENT_DETAILS_URL}/${
              item.m_woId
            }?${searchParams.toString()}`}
            className={`btn btn-sm bg-success text-white mx-2 `}
            state={{
              MOrders: MOrders,
            }}
          >
            Details
          </Link>
          <DeleteModalButton
            deleteFunc={deleteMWorkOrder}
            deleteParams={item.id}
          />
        </div>
      </td>
    </tr>
  );

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getMOrders();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  return (
    <div
      className="px-3 pb-3 pt-3"
      style={{
        marginLeft: 260,
        height: "100vh",
      }}
    >
      <h2 className="mt-0 mb-3">Manufacturer Orders</h2>
      {/* Table */}
      <div className="">
        <>
          <div className="">
            <div className="d-flex justify-content-end align-items-center ">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="me-1">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="bg-opacity-10 border border-primary rounded-end rounded-start"
                    >
                      {filterBy.find(
                        (filter) =>
                          filter.value === searchParams.get("filterBy") ||
                          (searchParams.get("filterBy") === null &&
                            filter.value === "all")
                      )?.name || "Filter By"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filterBy.map((filter) => (
                        <Dropdown.Item
                          key={filter.value}
                          onClick={() => handleFilterBy(filter.value)}
                        >
                          {filter.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}?`}
              />
              {(user?.permissions?.includes("m_wo_add") ||
                user?.roles === "admin") && (
                <SearchSWO
                  refreshFunc={getMOrders}
                  btnClasses="btn btn-primary"
                />
              )}
            </div>
            {(searchResults || MOrders) && (
              <TableOnly
                table_head={table_head}
                table_body={table_body}
                table_data={searchResults ? searchResults : MOrders}
                totalPages={totalPages}
              />
            )}

            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </>
      </div>
    </div>
  );
}
